module.exports = __webpack_public_path__ + "static/media/compact-disc.418a595a.svg";